import { ROUTE_PATH_ACTIVATE, URL_INTX_LOGIN_PAGE_EN_CA } from '../../constants';
import { AlertsPageTranslations } from '../types';

export const translations: AlertsPageTranslations = {
  docTitle: 'Monitoring and Alerts',
  pageTitle: 'Monitoring &amp; Alerts',
  featureList: [
    {
      // 'key' MUST BE the same as array index
      key: '0',
      heading: 'Constant protection to help you get ahead of identity fraud.',
      summary: [
        '<p>The most effective way to get ahead of identity fraud is to be aware of where and how your personal',
        'information is being used. Through monitoring and alerts you can be kept up-to-date on activity related to',
        'your online and financial identity and react quickly to potential fraud.</p>'
      ].join('\n')
    },
    {
      key: '1',
      heading: 'Online Identity Monitoring',
      summary: [
        '<p>We will survey underground and black market websites for the presence of personal information that you register - including emails, driver\'s licence, Social Insurance Number, and more - so you know what information may be compromised.</p>',
        '<h2 class="feature-item-heading">Financial Identity Monitoring</h2>',
        '<p>Your credit bureau profile will be monitored for new credit or loan',
        'applications so you are aware of certain activities that may indicate fraud happening in your name.</p>',
        '<h2 class="feature-item-heading">Identity Alerts</h2>',
        '<p>You will be alerted if we find your personal information online and to new credit',
        'applications made in your name so you can act quickly to better protect yourself from activity you did not',
        'authorize.</p>'
      ].join('\n'),
      action: {
        login: {
          to: '',
          href: URL_INTX_LOGIN_PAGE_EN_CA,
          children: 'Log In'
        },
        activate: {
          to: ROUTE_PATH_ACTIVATE,
          children: 'Activate'
        }
      }
    }
  ]
};
